import styled from 'styled-components';
import { Button } from 'antd';

export const StyledButton = styled(Button)`
  background-color: ${({ theme }) => theme.palette.primaryBrand};
  color: black;
  width: 100%;
  font-size: 18px;
  font-weight: 500;
  border-radius: 0;
  border: 0px;
  height: 80px;

  &:hover {
    background-color: white;
    color: black !important;
  }

  &:focus {
    background-color: black !important;
    color: white !important;
  }

  ${({ theme }) => theme.mediaQueries.PHONE} {
    width: 100%;
  }
`;
